import React, { useState } from "react";
import AdvanceTransactionList from "./components/AdvanceTransactionList";
import AdvanceTransactionForm from "./components/AdvanceTransactionForm";
import { useSelector } from "react-redux";

const AdvanceTransaction = () => {
  const [showForm, setShowForm] = useState(false);

  const { isEditAdvanceTransaction } = useSelector(
    (s) => s.advanceTransaction
  );

  return (
    <>
      {showForm ? (
        <AdvanceTransactionForm onBack={() => setShowForm(false)} />
      ) : (
        <AdvanceTransactionList onAddNew={() => setShowForm(true)} />
      )}
    </>
  );
};

export default AdvanceTransaction;
